import { render, staticRenderFns } from "./SingleCheckbox.vue?vue&type=template&id=0fd82fbd&"
import script from "./SingleCheckbox.vue?vue&type=script&lang=js&"
export * from "./SingleCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports